import React from "react"
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import BackToTop from "../../components/back-to-top"
import { Container, Row, Col } from "reactstrap"
import { LazyLoadImage } from "react-lazy-load-image-component"

const AndraDetora = () => {
  return (
    <Layout>
      <Seo title="Doctor Andra DeTora, DVM, CCRT, cVMA" />
      <div className="hero-adjustment pb-0">
        <div className="container">
          <div className="hero-content-wrapper">
            <div className="row no-gutters">
              <div className="col-12 col-md-7">
                <div className="hero-dog-bg">
                  <div className="dog-bg"></div>
                </div>
              </div>
              <div className="col-12 col-md-5">
                <div className="hero-video">
                  <div>
                    <div>
                      <div className="video-modal-btn no-video">
                        <LazyLoadImage
                          effect="blur"
                          src="/assets/img/tplo-video.jpg"
                          alt="video"
                          className="video-img img-fluid v-h"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-only-heading inner-page-title text-right arthroscopy-hero no-videoHero">
              <h1>
                Meet <br /> Dr. Andra
                <br />
                DeTora
              </h1>
            </div>
          </div>
        </div>
      </div>

      <Container className="acl-container mb-5 mt-5 mt-md-0">
        <div className="doctor-body">
          <Row className="border-none">
            <Col md={4} className="img-resp">
              <LazyLoadImage
                effect="blur"
                src="/assets/img/dr-andra-detora.jpg"
                alt="Doctor"
                className="img-fluid mb-4"
              />
            </Col>
            <Col md={8}>
              <p>
                Dr. Andra DeTora grew up in central New York and received her BS
                from St. Lawrence University in 2008. She then attended Ross
                University and received her DVM in 2012. She spent a few years
                in general practice in New York and Florida and then went on to
                complete a 1-year internship in Sports Medicine and
                Rehabilitation at Veterinary Orthopedic and Sports Medicine
                group in Maryland. She received her Certified Canine
                Rehabilitation Therapist certificate from the Canine
                Rehabilitation Institute in 2014. She is currently engaged in
                Acupuncture training.
              </p>
              <p>
                Andra has spent time working with her husband in Maryland, and
                Massachusetts as a surgery/rehab team to provide complete care
                for four-legged loved ones. She enjoys running, yoga, reading,
                winter sports, cooking, and spending time with her husband, Mike
                and daughter, Ava.
              </p>
            </Col>
          </Row>
          <div className="doctor-video">
            <Row className="border-none">
              <Col md={12}>
                <div className="embed-container">
                  <iframe
                    src="https://player.vimeo.com/video/489028400"
                    frameborder="0"
                    webkitAllowFullScreen
                    mozallowfullscreen
                    allowFullScreen
                    title="doctor"
                  ></iframe>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
      <BackToTop />
    </Layout>
  )
}

export default AndraDetora
